export default __webpack_public_path__ + "static/media/TruckIcon.dbf11d39.svg";